import { h } from '@stencil/core';

const camelCaseToDash = (str) => {
  return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
};

export const IcoDynamicContentLoader = (props) => {
  const { classes = {}, prefix = '', suffix = '', separator = '', section = '', ...attrs } = props;
  // NOTE:  compute the web component name as a string
  //        - this decouples the components from the DOM
  //          and lets us lazy load a component by it's string name...

  const CONTENT_LOADER = `${prefix}${separator}${camelCaseToDash(section)}${suffix}`;

  if (section === '') {
    return '';
  }

  return (
    <div class={classes}>
      <CONTENT_LOADER {...attrs} />
    </div>
  );
};
